/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.13.0
 * @since 1.0.1
 */
import { memo } from 'react';

import { IAttrStyled } from '../../../types/globalTypes';
import { ESkeletonKind } from './skeletonTypes';
import { SkeletonParagraphStyled } from './styled/SkeletonParagraphStyled';

export interface ISkeletonParagraphProps extends IAttrStyled {
    kind: ESkeletonKind;
}

const SkeletonButton = (props: ISkeletonParagraphProps) => <SkeletonParagraphStyled {...props}/>;

export default memo(SkeletonButton);
